import {
} from '../Redux.constants';

export const setPredictedQuestionTableData = (params) => ({
  type: 'SET_PREDICTED_QUESTION_TABLE_DATA',
  payload: params,
});

export const questionTableCellUpdateResults = (params) => ({
  type: 'QUESTION_TABLE_CELL_UPDATE_RESULTS',
  payload: params,
});

export const questionTableCellUpdate = (params) => ({
  type: 'QUESTION_TABLE_CELL_UPDATE',
  payload: params,
});

export const questionTableSubmit = (params) => ({
  type: 'QUESTION_TABLE_SUBMIT',
  payload: params,
});

export const absorbanceTableCellUpdate = (params) => ({
  type: 'ABSORBANCE_TABLE_CELL_UPDATE',
  payload: params,
});
